@if (sMenu) {
<div class="sidebar" [ngStyle]="{ display: activateGlobalNav ? 'none' : 'block' }">
  @if (!isResponsiveScreen && sMenu.navigationMenuTitle) {
  <div class="back-link">
    <a [routerLink]="sMenu.navigationMenuPath">
      <wp-icon name="chevron-left" size="md" class="navigation-back-icon"></wp-icon>
      <span class="navigation-title">{{ sMenu.navigationMenuTitle }}</span>
    </a>
  </div>
  } @if (isResponsiveScreen && getBackTitle()) {
  <div class="back-link" (click)="goBack()">
    <wp-icon name="chevron-left" size="md" class="navigation-back-icon"></wp-icon>
    <span class="navigation-responsive-title">
      {{ getBackTitle() }}
      @if (sMenu?.navigationMenuIndicator) {
      <span class="-indicator-chip">
        <app-indicator-chip-wrapper [indicator]="sMenu.navigationMenuIndicator"></app-indicator-chip-wrapper>
      </span>
      }
    </span>
  </div>
  } @if (isResponsiveScreen && previousMenus.length > 0 && sMenu.title) {
  <div class="section-heading">
    <span class="item-title"
      >{{ sMenu.title }}
      @if (sMenu.indicator) {
      <span class="-indicator-chip">
        <app-indicator-chip-wrapper [indicator]="sMenu.indicator"></app-indicator-chip-wrapper>
      </span>
      }
    </span>
  </div>
  } @for (section of sMenu.children; track section) {
  <div class="category-container" [ngClass]="{ 'drilled-category': isResponsiveScreen && isToggled }">
    <div class="category">
      @if ((!section.path && !isResponsiveScreen) || (!isToggled && previousMenus.length === 0)) {
      <span>{{ section.title }}</span>
      } @if (section.path && isToggled) {
      <app-link class="category-link" [to]="section.path" [disableRoute]="!section.path">
        @if (section.icon) {
        <lucide-icon [name]="section.icon" class="lucide-icon"></lucide-icon>
        }
        <span class="category-link-title">{{ section.title }}</span>
      </app-link>
      }
    </div>
    @if (!isResponsiveScreen) {
    <wp-nav [items]="navItemsPerSection[$index] || []" size="medium" theme="brand" (wpClick)="onNavClick($event)">
      @for (iconSlot of navIconSlotsPerSection[$index]; track iconSlot.slotName) {
      <wp-icon [attr.slot]="iconSlot.slotName" [name]="iconSlot.iconName" size="sm"></wp-icon>
      }
    </wp-nav>
    } @else {
    <ul class="section-items parent-category">
      <ng-container *ngTemplateOutlet="renderItems; context: { items: section.children }"></ng-container>
    </ul>
    }
  </div>
  }
  <ng-template #renderItems let-items="items">
    @for (item of items; track item) {
    <li>
      <div class="item-row" [ngClass]="{ expandable: item.children }" (click)="item.children && toggle(item, $event)">
        @if (item.path) {
        <app-link
          class="item-link"
          [to]="item.path"
          [disableRoute]="!item.path"
          (click)="onSelectGrandchild(item, $event)">
          @if (item.icon) {
          <lucide-icon [name]="item.icon" class="lucide-icon" [size]="20"></lucide-icon>
          }
          <span class="item-title" [ngClass]="getTitleClass(item)">
            {{ item.title }}
            @if (item.indicator) {
            <span class="-indicator-chip">
              <app-indicator-chip-wrapper [indicator]="item.indicator"></app-indicator-chip-wrapper>
            </span>
            }
          </span>
        </app-link>
        } @if (!item.path && item.children) {
        <span class="item-title has-children" [ngClass]="[getTitleClass(item), item.expanded ? 'expanded' : '']">
          {{ item.title }}
          @if (item.indicator) {
          <span class="-indicator-chip">
            <app-indicator-chip-wrapper [indicator]="item.indicator"></app-indicator-chip-wrapper>
          </span>
          }
        </span>
        } @if (item.children) {
        <wp-icon
          class="category-icon"
          [name]="item.expanded ? 'chevron-down' : 'chevron-right'"
          (click)="toggle(item, $event)"
          size="md">
        </wp-icon>
        }
      </div>
      @if (item.expanded && item.children) {
      <ul class="child-items">
        <ng-container *ngTemplateOutlet="renderItems; context: { items: item.children }"></ng-container>
      </ul>
      }
    </li>
    }
  </ng-template>
</div>
} @if (activateGlobalNav) {
<div class="global-nav-container" [ngStyle]="{ display: activateGlobalNav ? 'block' : 'none' }">
  <app-nav-container
    [menu]="globalNav"
    [userName]="userName"
    [userMail]="userMail"
    [isUserLoggedIn]="isUserLoggedIn"></app-nav-container>
</div>
}
